<template>
  <div id="links">
    <p id="links-handle">
      Links
    </p>
    <div id="links-content">
      <div class="link" v-for="(link,index) in links" v-bind:key="index">
        <div v-if="link.room == room.id">
          <a v-if="link.isURL" v-bind:href="link.link" target="_blank">{{link.title}}</a>
          <div class="deleteButton" v-on:click="deleteLink(link._id)"><img src="../assets/icons/trash.svg"/></div>
        </div>
      </div>

      <form @submit.prevent="addLink">
        <div class="form-group">
          <input type="text" class="form-control" v-model="linkTitle" placeholder="Title" />
          <input type="text" class="form-control" v-model="newLink" placeholder="URL" />
        </div>
      </form>
      <!-- <button v-if="this.username == 'host'" v-on:click="addLink"> add link </button> -->
      <button v-on:click="addLink">Add link</button>
    </div>
  </div>
</template>

<script>
import LinkService from "../LinkService";
import interactions from "../interactions";

export default {
  name: "Linkblok",
  props: {
    username: {
      type: String
    },
    activeRoom: {
      type: Object
    }
  },

  data() {
    return {
      newLink: null,
      linkTitle: null,
      links: [],
      x: null,
      y: null,
      room: this.activeRoom,
      fold: true,
      ratioLock: false
    };
  },

  mounted() {
    interactions.dragDrop("#links", "#links-handle", this.x, this.y, this.ratioLock);
    interactions.enableFold("#links-handle", "#links-content", this.fold);
  },

  async created() {
    this.links = await this.getLinks();
  },

  methods: {
    async addLink() {
      // ongeveer het zelfde als "sendToDatabase() uit "chatbox.vue"
      let allowedToAdd = true;
      if (this.linkTitle == null) {
        alert("Please insert a link title");
        allowedToAdd = false;
      }

      if (this.newLink == null) {
        alert("Please insert a link");
        allowedToAdd = false;
      }
      // check if valid url
      const isValidu = this.isValidURL(this.newLink);
      
      if (!isValidu) {
        alert("Please supply a valid URL");
        allowedToAdd = false;
      }

      // check if string starts with http  and otherwise adds it
      if (!this.newLink.startsWith("http")) {
        //  this.newLink = `http://www.${this.newLink}`  (maybe for later)
        alert("Add http or https to start the URL");
        allowedToAdd = false;
      }

      if (allowedToAdd) {
        const linkInfo = {
          room: this.activeRoom,
          title: this.linkTitle,
          link: this.newLink,
          isURL: isValidu
        };

        await LinkService.insertLink(linkInfo);
        this.newLink = null;
        this.linkTitle = null;
      }

      this.links = await this.getLinks(); //refresh the links
      this.$socket.emit('newLinkPosted')


      
    },

    async getLinks() {
      return await LinkService.getLinks();
    },

    async deleteLink(id) {
      await LinkService.deleteLink(id);
      this.links = await LinkService.getLinks();
      this.$socket.emit('newLinkPosted')
    },

    isValidURL(str) {
      var pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      ); // fragment locator
      return !!pattern.test(str);
    },

    checkIfStringEmpty(str) {
      return str == "" || str == null ? true : false;
    },

    async updateLinks() {
      this.links = await this.getLinks();
    }
  },

  sockets:{
    newLink : async function(){
      // console.log('new link') 
      this.links = await this.getLinks()
      }

    }

};
</script>

<style>
#links p {
  top: 0;
  font-size: 16px;
  margin-block-start: 0;
  padding: 5px;
  border-bottom: var(--default-border);
}

#links #links-handle {
  margin: 0;
  overflow:hidden;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

#links {
  position: absolute;
  border: var(--invisible-windows-border);
  z-index: 1000;
  margin-top:302px;
  filter: var(--drop-shadow);
}

#links-content {
  width:200px;
  overflow-y: auto;
}

.deleteButton {
  padding-left: 2px;
  text-align: right;
  float: right;
  cursor: pointer;
}

.deleteButton img {
  height:0.8em;
}

.plainLinktext {
  display: inline-block;
}

.link {
  color:var(--default-link-color);
  margin:5px;
}

</style>
